module.exports = __webpack_public_path__ + "static/insight-logo-964083d003551fd703c3b587699e01d0.png";